const path = require("path");
const fs = require("fs");
const child_process = require("child_process");
const iconv = require("iconv-lite");
const {app, BrowserWindow, dialog, shell, Menu} = require("electron");
let env = {devtools: true, url: ""};
let animationWindow;
try {
	env = require("../env.json");
} catch (error) {}
var exeMap = {};
var procMap = {};
getAllExe(path.join(__dirname, "../bin"));
function getAllExe(dir) {
	fs.readdir(dir, function (err, files) {
		if (err) return;
		files.forEach(function (file) {
			if (process.platform != "win32" || file.endsWith(".exe")) {
				exeMap[file] = path.join(dir, file); // JSON.stringify(path.join(dir, file));
			}
			getAllExe(path.join(dir, file));
		});
	});
}

/**
 * 创建浏览器窗口
 * @param {string} [url]
 * @returns
 */
function createWindow(url, options, isfile) {
	let size = require("electron").screen.getPrimaryDisplay().workAreaSize;
	let nowwidth, nowheight;
	size.height = size.height + 40;
	if (size.height >= 800 && size.width < 1180) {
		nowwidth = 1000;
		nowheight = 750 / 1.18;
	} else if (size.height >= 1080 || size.height < 676) {
		nowwidth = parseInt((1180 * size.width) / 1920);
		nowheight = parseInt((750 * size.width) / 1920);
	} else if (size.height >= 800) {
		nowwidth = 1180;
		nowheight = 750;
	} else if (size.height >= 676) {
		nowwidth = 1000;
		nowheight = 750 / 1.18;
	}
	console.log("size", size);
	console.log("nowwidth", nowwidth);
	console.log("nowheight", nowheight);
	let defaultOptions = {
		resizable: false,
		width: nowwidth,
		height: parseInt(nowheight),
		// minWidth: 1180,
		// minHeight: 750,
		show: false,
		frame: false,
		minimizable: true,
		maximizable: true,
		closable: true,
		webPreferences: {
			webSecurity: false,
			webviewTag: true,
			allowDisplayingInsecureContent: true,
			nodeIntegration: true,
			contextIsolation: false,
			// 新版本electron中remote模块会被逐渐弃用，需要声明  启用模块  后使用
			enableRemoteModule: true,
			preload: path.join(__dirname, "preload.js"),
		},
	};
	Object.assign(defaultOptions, options);
	if (defaultOptions.parent === true) defaultOptions.parent = this;
	let win = new BrowserWindow(defaultOptions);

	win.webContents.on("new-window", function (event, url, frameName) {
		event.preventDefault();
		if (frameName && (frameName.startsWith("oauth2Login_") || frameName.endsWith("_auth"))) {
			let page = new BrowserWindow({
				width: 600,
				height: 600,
				frame: true,
				parent: win,
				modal: true,
				center: true,
				webPreferences: {
					// webSecurity: false,
					// preload: __dirname + '/preload.js',
					nativeWindowOpen: true,
					nodeIntegration: false,
				},
			});
			page.loadURL(url);
			event.newGuest = page;
			return;
		}
		if (win.filterExternalURL && win.filterExternalURL(url)) shell.openExternal(url);
		else {
			event.newGuest = createWindow(url);
		}
	});

	// win.webContents.on("ready-to-show", function () {
	// 	win.show();
	// 	win.webContents
	// 		.executeJavaScript("window.store.clearAll();")
	// 		.then((res) => {
	// 			// console.log("触发成功");
	// 		})
	// 		.catch(() => {});
	// });

	if (env.devtools) {
		win && win.webContents.openDevTools();
	}

	// win.loadFile(path.join(__dirname, "../../dist/index.html"));

	if (url && !isfile) win.loadURL(url);
	else if (url && isfile) win.loadFile(path.join(__dirname, url));
	else win.loadFile(path.join(__dirname, "../static/index.html"));

	//然后加载应用的 index.html
	// win.webContents.on("did-fail-load", (err) => {
	// console.log("did-fail-load");
	// win.loadFile(path.join(__dirname, "../static/index.html"));
	// });
	// win.webContents.on("did-finish-load", (e) => {
	// 	console.log("did-finish-load", e);
	// });
	win.on("close", (e) => {
		// 取消引用 window 对象，如果你的应用支持多窗口的话，
		// 通常会把多个 window 对象存放在一个数组里面，
		// 与此同时，你应该删除相应的元素。
		e.preventDefault();
		win.webContents
			.executeJavaScript("window.store.clearAll();")
			.then((res) => {
				// console.log("触发成功");
				win.destroy();
				win = null;
			})
			.catch(() => {
				win.destroy();
				win = null;
			});
		// });
	});
	return win;
}

let api = {
	createWindow,
	isWin32() {
		return process.platform == "win32";
	},
	getVersion() {
		return 10000;
	},
	getArgs() {
		return process.argv;
	},
	getPath(name) {
		if (name == "main") return require.resolve("../main.js");
		return app.getPath(name);
	},
	setPath(name, value) {
		if (name == "main") return require.resolve("../main.js");
		return app.setPath(name, value);
	},
	//#region 文件相关
	/**
	 * 选择保存文件路径，返回文件路径
	 * @param {string} [title] 默认文件名称
	 * @param {string} [ext] 限定文件后缀
	 * @returns {Promise<string>}
	 */
	pickSaveFile(title, ext) {
		var win = this;
		return new Promise(function (resolve, reject) {
			var pms = dialog.showSaveDialog(
				win,
				{
					defaultPath: title + "-副本",
					nameFieldLabel: title,
					filters: [
						{
							name: "*",
							extensions: ext
								? ext.split(",").filter(function (x) {
										return x;
								  })
								: [],
						},
					],
				},
				function (filePath) {
					resolve(filePath);
				}
			);
			if (pms && pms.then)
				pms.then(function (x) {
					resolve(x.filePath);
				});
		});
	},
	/**
	 * https://www.electronjs.org/docs/api/dialog#dialogshowopendialogbrowserwindow-options
	 * 选取文件，返回文件路径
	 * @param {string} [ext] 文件后缀
	 * @param {boolean} [multi]
	 * @returns {Promise<string>}
	 */
	pickFile(ext, multi) {
		var win = this;
		var properties = ["openFile"];
		multi && properties.push("multiSelections");
		return new Promise(function (resolve, reject) {
			var pms = dialog.showOpenDialog(
				win,
				{
					properties: properties,
					filters: [
						{
							name: "*",
							extensions: ext
								? ext.split(",").filter(function (x) {
										return x;
								  })
								: [],
						},
					],
				},
				resolve
			);
			if (pms && pms.then)
				pms.then(function (data) {
					resolve(multi ? data.filePaths : data.filePaths && data.filePaths[0]);
				});
		});
	},
	pickDir(defaultPath) {
		var win = this;
		return new Promise(function (resolve, reject) {
			var pms = dialog.showOpenDialog(
				win,
				{
					defaultPath,
					properties: ["openDirectory"],
				},
				function (filePaths) {
					resolve(filePaths && filePaths[0]);
				}
			);
			if (pms && pms.then)
				pms.then(function (data) {
					resolve(data.filePaths && data.filePaths[0]);
				});
		});
	},
	/**
	 * 文件修改时间，文件不存在返回0
	 * @param {string} path 文件路径
	 * @returns {number}
	 */
	getFileModifyAt(path) {
		return new Promise(function (resolve, reject) {
			fs.stat(path, (err, data) => (err ? resolve(0) : resolve(data.mtimeMs)));
		});
	},
	/**
	 * 读取
	 * @param {string} path 文件路径
	 * @param {string} [encode] 编码
	 * @returns
	 */
	readFile(path, encode) {
		return new Promise(function (resolve, reject) {
			fs.readFile(path, encode || "utf8", (err, data) => (err ? reject(err) : resolve(data)));
		});
	},
	/**
	 * 写入
	 * @param {string} path
	 * @param {string} data
	 * @returns
	 */
	writeFile(path, data) {
		return new Promise(function (resolve, reject) {
			fs.writeFile(path, data, (err) => (err ? reject(err) : resolve()));
		});
	},
	readdir(path) {
		return new Promise(function (resolve, reject) {
			fs.readdir(path, function (err, files) {
				err ? reject(err) : resolve(files);
			});
		});
	},
	unlink(path) {
		return new Promise(function (resolve, reject) {
			fs.unlink(path, function (err, files) {
				err ? reject(err) : resolve(files);
			});
		});
	},
	showItemInfolder(filepath) {
		if (process.platform == "win32") filepath = filepath.replace(/\//g, "\\");
		return shell.showItemInFolder(filepath);
	},
	stat(path) {
		return new Promise(function (resolve, reject) {
			fs.stat(path, function (err, stat) {
				err ? reject(err) : resolve(stat);
			});
		});
	},
	mkdirs(dir) {
		var dirs = dir.split(/[\/\\]/);
		let pms = Promise.resolve();
		let s = "";
		for (var i = 0; i < dirs.length; i++) {
			let tmp = (s = s + (s ? "/" + dirs[i] : dirs[i]));
			pms = pms.then(
				() =>
					new Promise((resolve, reject) =>
						fs.exists(tmp, (ok) =>
							ok ? resolve() : fs.mkdir(tmp, (err) => (err ? reject(err) : resolve()))
						)
					)
			);
		}
		return pms;
	},
	//#endregion
	//#region 进程相关
	procCreate(cmds, opts) {
		opts = Object.assign({}, opts);
		var cmd = cmds[0];
		if (process.platform == "win32" && !cmd.endsWith(".exe")) cmd += ".exe";
		if (exeMap[cmd]) {
			cmd = exeMap[cmd];
		}
		var proc = child_process.spawn(cmd, cmds.slice(1), opts);
		if (opts.spawnMode) {
			var name = path.basename(process.argv0).slice(0, -4);
			if (!opts.stdout) opts.stdout = path.join(app.getPath("temp"), name + "-out" + Math.random());
			if (!opts.stderr) opts.stderr = path.join(app.getPath("temp"), name + "-err" + Math.random());
			var ws = fs.createWriteStream(opts.stdout);
			if (opts.stdout == opts.stderr) {
				proc.stdout.pipe(ws, {end: false});
				proc.stderr.pipe(ws, {end: false});
			} else {
				proc.stdout.pipe(ws);
				proc.stderr.pipe(fs.createWriteStream(opts.stderr));
			}
			var ret = {};
			ret.pid = proc.pid;
			ret.stdout = opts.stdout;
			ret.stderr = opts.stderr;
			procMap[proc.pid] = proc;
			proc.data = ret;
			proc._pms = new Promise(function (resolve, reject) {
				proc.on("exit", function (code) {
					ws.end();
					ret.stoped = true;
					code ? reject(code) : resolve(code);
				});
			});
			return ret;
		}
		return new Promise(function (resolve, reject) {
			var stdout = [];
			proc.stdout.on("data", function (buf) {
				stdout.push(buf);
			});
			var stderr = [];
			proc.stderr.on("data", function (buf) {
				stderr.push(buf);
			});
			proc.on("exit", function (code) {
				stdout = Buffer.concat(stdout);
				stderr = Buffer.concat(stderr);
				if (process.platform == "win32") {
					stdout = iconv.decode(stdout, "gbk").replace(/\r\n/g, "\n");
					stderr = iconv.decode(stderr, "gbk").replace(/\r\n/g, "\n");
				} else {
					stdout += "";
					stderr += "";
				}
				code ? reject({code, stdout, stderr}) : resolve({stdout, stderr});
			});
		});
	},
	procGet(pid) {
		var proc = procMap[pid];
		if (!proc) return null;
		["connected", "exitCode", "killed", "signalCode", "spawnargs", "spawnfile"].forEach((k) => {
			proc.data[k] = proc[k];
		});
		return proc.data;
	},
	procWait(pid) {
		var proc = procMap[pid];
		if (!proc) return Promise.reject("not found proc:" + pid);
		return proc._pms;
	},
	procWrite(pid, base64) {
		var proc = procMap[pid];
		if (proc) {
			proc.stdin.write(Buffer.from(base64, "base64"));
			return true;
		}
		return false;
	},
	procKill(pid, code) {
		var proc = procMap[pid];
		if (proc) {
			code == null ? proc.kill() : proc.kill(code);
			delete procMap[pid];
			return true;
		}
		return false;
	},
	procList() {
		var list = [];
		for (var k in procMap) {
			list.push(api.procGet(k));
		}
		return list;
	},
	exec(cmds, opts) {
		if (typeof cmds == "string") cmds = cmds.split(" ");
		var cmd = cmds[0];
		if (process.platform == "win32" && !cmd.endsWith(".exe")) cmd += ".exe";
		if (exeMap[cmd]) {
			cmds[0] = JSON.stringify(exeMap[cmd]);
		}
		return new Promise(function (resolve, reject) {
			child_process.exec(
				cmds.join(" "),
				Object.assign({encoding: "buffer"}, opts),
				function (err, stdout, stderr) {
					if (process.platform == "win32") {
						stdout = iconv.decode(stdout, "gbk").replace(/\r\n/g, "\n");
						stderr = iconv.decode(stderr, "gbk").replace(/\r\n/g, "\n");
					} else {
						stdout += "";
						stderr += "";
					}
					err ? reject({err, stdout, stderr}) : resolve({stdout, stderr});
				}
			);
		});
	},
	//#endregion
	eval(code) {
		var c = {};
		var win = this;
		Object.keys(console).forEach((k) => {
			c[k] = function () {
				console[k].apply(console, arguments);
				try {
					var args = Array.from(arguments);
					args.unshift(k);
					win.webContents.send("console", args);
				} catch (error) {}
			};
		});
		return new Function("require", "console", code).call(this, require, c);
	},
	createAnimationWindow() {
		// api.createWindow("../static/animation.html", {}, true);
		animationWindow = new BrowserWindow({
			width: 200,
			height: 200,
			frame: false, //是否带工具栏
			transparent: true,
			resizable: false,
			webPreferences: {
				devTools: false,
			},
		});
		animationWindow.on("close", () => {
			animationWindow = null;
		});
		animationWindow.loadFile(path.join(__dirname, "../static/animation.html"));
	},
	closeAnimationWindow() {
		animationWindow.close();
	},
};
module.exports = api;
